import React, { useEffect } from "react";
import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";
import { Outlet, useLocation } from "react-router-dom";

function ScrollManager() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth", block: "start" }), 80);
        } else {
            window.scrollTo(0, 0);
        }
    }, [pathname, hash]);
    return null;
}

export default function PublicLayout() {
    return (
        <div className="min-h-screen bg-white text-[#0b2545]">
            <ScrollManager />
            <PublicHeader />
            <main className="pt-[72px]">
                <Outlet />
            </main>
            <PublicFooter />
        </div>
    );
}
